import { useCallback } from 'react';
import { toast } from 'sonner';

import { buildUrlFromMetadata } from '@/utils/deeplink';

export function useDeepLinkNavigation() {
  const navigateToDeepLink = useCallback((metadata: Record<string, unknown>) => {
    const url = buildUrlFromMetadata(metadata);
    if (url) {
      window.open(url, '_blank', 'noopener');
    } else {
      toast.error('This notification does not have a linked page.');
    }
  }, []);

  return { navigateToDeepLink };
}
